<template>
	<div class="badgepopup">
    <div class="popup">
      <em class='close cursor' @click="close"></em>
      <img :src="popupData.path" alt>
      <div>
        <h2>{{popupData.name}}</h2>
        <p>{{popupData.badge_msg}}</p>
      </div>
    </div>
	</div>
</template>
<script>
export default {
  name: "badgepopup",
  data() {
    return {
     
    };
  },
  props:['popupData'],
  methods: {
    close(){
      this.$emit('close');
    }
  }
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.badgepopup {
  position: absolute;
  z-index: 101;
  top: 0;
  left:0;
  width:100%;
  height:100%;
  background:rgba(0,0,0,.6);
}
.popup{
  width:588px;
  height:364px;
  background:#F1F3F4;
  border-radius:14px;
  position:absolute;
  left:50%;
  top:50%;
  margin-left:-294px;
  margin-top:-182px;
  display:flex;
  img{
    min-width: 160px;
    width: 160px;
    height: 160px;
    margin: 83px 25px 0 50px;
  }
  div{
    padding:112px 55px 0 0;
    text-align:left;
    overflow: hidden;

  }
  h2{
    font-size:24px;
    color:rgb(0,84,126);
    margin-bottom:20px;

  }
  p{
    color:rgba(0,84,126, .9);
    font-size:18px;
    line-height:28px;
  }
  .close{
    width:34px;
    height:34px;
    background:url("../../../assets/img/common/close.png") no-repeat center;
    background-size:34px;
    position:absolute;
    right:-34px;
    top:-34px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/class/badgepopup.vue